import { Accordion } from "flowbite-react"
  const QaServiceFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What tools, technologies, and frameworks do you support?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Our team of experts is proficient in a wide range of tools, technologies, and frameworks to ensure that we can meet the specific needs of every project and client. Here is a brief overview:<br></br>
                  <ul className="list mb-0 mt-3">
                      <li><span className="text-textcolor">Test Automation:</span><br></br>
                        Frameworks: Selenium, Appium, TestNG, JUnit, Cucumber, Robot Framework
                        Tools: QTP/UFT, Ranorex, Katalon Studio, TestComplete, Playwright, Cypress
                      </li>
                      <li><span className="text-textcolor">Performance Testing:</span><br></br>
                        JMeter, LoadRunner, NeoLoad, WebLoad, BlazeMeter
                      </li>
                      <li><span className="text-textcolor">Test Management:</span><br></br>
                        JIRA (with Zephyr or Xray), TestRail, QTest, Quality Center/ALM, QAJarvis
                      </li>
                      <li><span className="text-textcolor">Continuous Integration & Continuous Deployment (CI/CD):</span><br></br>
                        Jenkins, Bamboo, Travis CI, CircleCI, GitLab CI
                      </li>
                      <li><span className="text-textcolor">Mobile Testing:</span><br></br>
                        Espresso, XCTest, Detox, BrowserStack, Sauce Labs
                      </li>
                      <li><span className="text-textcolor">API Testing:</span><br></br>
                        Postman, SoapUI, Rest-Assured, Insomnia
                      </li>
                      <li><span className="text-textcolor">Postman, SoapUI, Rest-Assured, Insomnia</span><br></br>
                        Cucumber, SpecFlow, Behave
                      </li>
                      <li><span className="text-textcolor">Cross-Browser Testing Platforms:</span><br></br>
                        Selenium Grid, Sauce Labs, BrowserStack, CrossBrowserTesting
                      </li>
                      <li><span className="text-textcolor">Version Control Systems:</span><br></br>
                        Git, SVN, Mercurial
                      </li>
                      <li><span className="text-textcolor">Cloud Testing Platforms:</span><br></br>
                        AWS Device Farm, Firebase Test Lab, Sauce Labs
                      </li>
                      <li><span className="text-textcolor">Defect Tracking:</span><br></br>
                        JIRA, Bugzilla, Mantis, Redmine
                      </li>
                      <li><span className="text-textcolor">Collaboration & Communication:</span><br></br>
                        Slack, Microsoft Teams, Trello
                      </li>
                      <li><span className="text-textcolor">Security Testing Tools:</span><br></br>
                        OWASP ZAP, Burp Suite, Nessus
                      </li>
                      <li><span className="text-textcolor">Accessibility Testing:</span><br></br>
                        AXE, WAVE, VoiceOver, JAWS
                      </li>
                    </ul><br></br>
                    This is not an extensive list, as the software testing landscape is vast and constantly evolving. We regularly train our teams and update our toolkit to include the latest and most effective technologies. <br></br>
                    If there&apos;s a specific tool, technology, or framework you want to utilize, or have questions about something not listed here, please let us know. Our adaptability and dedication to staying at the forefront of technology ensure we can provide optimal testing solutions tailored to your needs.<br></br>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How much does QA outsourcing cost?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of QA outsourcing varies depending on the specific needs of the client. Every project has different requirements, so we can&apos;t offer a one-size-fits-all price. Please contact us with your specific needs so we can provide a more accurate estimate.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How to choose the right QA outsourcing vendor?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  When choosing a QA outsourcing vendor, there are a few key factors to consider:<br></br>
                  <ul className="list mb-0 mt-3">
                      <li><span className="text-textcolor">Industry expertise: </span>
                        Choose a vendor with experience in your industry and with the type of software you&apos;re developing.
                      </li>
                      <li><span className="text-textcolor">Range of services: </span>
                        Make sure the vendor offers the full range of QA services you need, including functional testing, performance testing, security testing, and more.
                      </li>
                      <li><span className="text-textcolor">Communication process: </span>
                        Choose a vendor that communicates clearly and regularly. You should be able to easily contact the vendor with questions or concerns.
                      </li>
                      <li><span className="text-textcolor">Team qualifications: </span>
                        Make sure the vendor has a team of experienced and qualified QA professionals.
                      </li>
                      <li><span className="text-textcolor">Quality control measures: </span>
                        Ask the vendor about their quality control measures to ensure that they deliver high-quality testing services.
                      </li>
                      <li><span className="text-textcolor">Relevant experience: </span>
                        Choose a vendor with experience in projects similar to yours.
                      </li>                     
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the benefits of QA outsourcing?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  QA outsourcing offers several benefits for businesses, including:<br></br>
                  <ul className="list mb-0 mt-3">
                      <li><span className="text-textcolor">Reduced costs: </span>
                        Outsourcing QA can save you money on the cost of hiring and training an in-house QA team.
                      </li>
                      <li><span className="text-textcolor">Faster time to market: </span>
                        QA outsourcing can help you get your software to market faster by freeing up your in-house team to focus on other tasks, such as development.
                      </li>
                      <li><span className="text-textcolor">Increased test efficiency: </span>
                        QA outsourcing providers have the expertise and resources to test your software more efficiently than you could in-house.
                      </li>
                      <li><span className="text-textcolor">Better customer satisfaction: </span>
                        QA outsourcing can help you deliver high-quality software that meets your customers&apos; needs, leading to better customer satisfaction.
                      </li>
                      <li><span className="text-textcolor">Optimal resource utilization: </span>
                        Outsourcing QA can free up your in-house team to focus on their core competencies, while the QA outsourcing provider focuses on what they do best.
                      </li>                
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is a quality assurance service?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  A Quality Assurance (QA) service is a systematic process of testing and validation to ensure that IT products, like mobile and web applications, meet quality standards, work correctly, and provide a positive user experience. It involves activities such as testing for functionality, performance, security, usability, compatibility, and more to identify and fix issues, ultimately ensuring a high-quality product.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> What are the types of quality assurance?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Here are three primary types of quality assurance:<br/>
                  <ul className="list mb-0 mt-3">
                      <li><span className="text-textcolor">Functional Quality Assurance: </span>
                        Focuses on ensuring products or software meet functional requirements and work correctly.
                      </li>
                      <li><span className="text-textcolor">Structural Quality Assurance: </span>
                        Concentrates on optimizing processes and testing hardware components.
                      </li>
                      <li><span className="text-textcolor">Compliance and Regulatory Quality Assurance: </span>
                        Ensures products meet safety and regulatory standards in industries like pharmaceuticals, medical devices, and food.
                      </li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default QaServiceFAQ
